import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientData, ClientSegment } from '@interfaces';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientDataService {
  constructor(private http: HttpClient) {}

  callClientData(): Observable<ClientData> {
    return this.http.get<ClientData>(`secure/client-data`);
  }

  callClientFlags(): Observable<ClientSegment> {
    return this.http.get<ClientSegment>(`secure/client-flags`);
  }
}
